import React, { useEffect, useId } from "react";

const MobileSlidesSlider = ({ slides }) => {
  const uniqueId = useId().replace(/:/g, "-");
  const sliderClass = `tf-sw-mobile-slides-${uniqueId}`;

  useEffect(() => {
    // Initialize Swiper immediately - images are already preloaded in Home.jsx
    const initializeSlider = () => {
      if (!window.Swiper) {
        setTimeout(initializeSlider, 100);
        return;
      }

      const sliderElement = document.querySelector(`.${sliderClass}`);
      if (!sliderElement || sliderElement.swiper) {
        return;
      }

      // Initialize Swiper immediately since images are preloaded
      const preview = parseFloat(sliderElement.dataset.preview) || 4.6;
      const tablet = parseFloat(sliderElement.dataset.tablet) || 2.6;
      const mobile = parseFloat(sliderElement.dataset.mobile) || 1.6;
      const spacingLg = parseInt(sliderElement.dataset.spaceLg) || 30;
      const spacingMd = parseInt(sliderElement.dataset.spaceMd) || 15;
      const perGroup = parseInt(sliderElement.dataset.pagination) || 1;
      const perGroupMd = parseInt(sliderElement.dataset.paginationMd) || 1;
      const perGroupLg = parseInt(sliderElement.dataset.paginationLg) || 1;

      new window.Swiper(`.${sliderClass}`, {
        slidesPerView: mobile,
        spaceBetween: spacingMd,
        speed: 1000,
        slidesPerGroup: perGroup,
        preloadImages: true,
        updateOnWindowResize: true,
        observer: true,
        observeParents: true,
        watchSlidesProgress: true,
        breakpoints: {
          768: {
            slidesPerView: tablet,
            spaceBetween: spacingLg,
            slidesPerGroup: perGroupMd,
          },
          1150: {
            slidesPerView: preview,
            spaceBetween: spacingLg,
            slidesPerGroup: perGroupLg,
          },
        },
      });
    };

    // Initialize after DOM is ready
    setTimeout(initializeSlider, 100);
  }, [sliderClass, uniqueId, slides]);

  return (
    <>
      <style>
        {`
          /* Hide on desktop, show only on mobile */
          .mobile-slides-slider-wrapper {
            display: none;
          }

          @media (max-width: 767px) {
            .mobile-slides-slider-wrapper {
              display: block;
            }
          }

          /* Blue hover effect for titles */
          .${sliderClass} .collection-item-v3 .collection-content .title {
            transition: color 0.3s ease;
          }
          
          .${sliderClass} .collection-item-v3:hover .collection-content .title {
            color: #0e5aa7 !important;
          }
          
          /* Hide arrow icons on slider items */
          .${sliderClass} .collection-item-v3 .collection-image .box-icon {
            display: none !important;
          }
          
          .${sliderClass} .collection-item-v3 .collection-image::before,
          .${sliderClass} .collection-item-v3 .collection-image::after {
            display: none !important;
          }
          
          /* Change red border/outline to blue on hover */
          .${sliderClass} .collection-item-v3:hover .collection-image,
          .${sliderClass} .collection-item-v3 .collection-image:hover,
          .${sliderClass} .collection-item-v3 .collection-image:focus,
          .${sliderClass} .collection-item-v3 .collection-image:focus-visible {
            border-color: #0e5aa7 !important;
            outline-color: #0e5aa7 !important;
            outline: 2px solid #0e5aa7 !important;
          }

          /* Hide content below images */
          .${sliderClass} .collection-item-v3 .collection-content {
            display: none !important;
          }

          /* Hide pagination dots */
          .sw-pagination-mobile-slides-${uniqueId} {
            display: none !important;
          }
          
          /* Ensure images load and display immediately */
          .${sliderClass} .collection-item-v3 .collection-image img {
            display: block !important;
            width: 100% !important;
            height: auto !important;
            opacity: 1 !important;
            visibility: visible !important;
            transition: opacity 0.2s ease;
          }
          
          /* Ensure slides are visible before Swiper initializes */
          .${sliderClass} .swiper-wrapper {
            display: flex !important;
          }
          
          .${sliderClass} .swiper-slide {
            visibility: visible !important;
            opacity: 1 !important;
          }
          
          /* Preload next slide images */
          .${sliderClass} .swiper-slide-next .collection-image img,
          .${sliderClass} .swiper-slide-prev .collection-image img {
            will-change: transform;
          }
        `}
      </style>
      <section
        className="flat-spacing-27-edit mobile-slides-slider-wrapper"
        style={{ paddingTop: "20px", paddingBottom: "0px" }}
      >
        <div className="container-full slider-layout-right">
          <div
            dir="ltr"
            className={`swiper ${sliderClass} sw-wrapper-right`}
            data-preview="4.6"
            data-tablet="2.6"
            data-mobile="1.4"
            data-space-lg="30"
            data-space-md="15"
            data-pagination="1"
            data-pagination-md="1"
            data-pagination-lg="1"
          >
            <div className="swiper-wrapper">
              {slides.map((slide, index) => (
                <div key={index} className="swiper-slide">
                  <div className="collection-item-v3 hover-img">
                    <a
                      href={slide.buttonLink || "/shop-default"}
                      className="collection-image img-style"
                    >
                      <img
                        src={slide.image}
                        alt={slide.alt || slide.title || "slide"}
                        loading="eager"
                        fetchpriority={index < 2 ? "high" : "auto"}
                        decoding="async"
                      />
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MobileSlidesSlider;
